import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ModalLoginService } from '../services/modal-login.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(private authSrv: AuthService, private router: Router, private modalAuth: ModalLoginService) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    const loggedIn = await this.authSrv.isLoggedIn();
    if (loggedIn) {
      this.modalAuth.closeModalLogin();
      
      const pending2FA = sessionStorage.getItem('pending2FAAuth');
      if (pending2FA && route.routeConfig?.path !== 'verify-2fa') {
        return this.router.parseUrl('/verify-2fa');
      }
      
      return this.router.parseUrl('/oportunidades');
    }
    return true;
  }
  
}
